import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import RegistrationForm from './RegistrationForm'
import { AuthenticationService } from '../../services'
import { useSelector } from 'react-redux'
import SlidingPane from 'react-sliding-pane'
import { isMobileDevice } from '../../helpers'

export const RegistrationPane = (props) => {
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const { productName, gsxAuthTokenURL } = useSelector(
    (state) => state.application
  )
  const [isEmailAvailable, setEmailAvailability] = useState(true)
  const [emailAvailabilityMessage, setEmailAvailabilityMessage] = useState(true)
  const [isValidEmail, setIsValidEmail] = useState(true)
  const [signUpResponse, setSignUpResponse] = useState(null)
  const [error, setError] = useState(null)

  const checkIsEmailAvailable = (event) => {
    event.preventDefault()
    const { value } = event.currentTarget
    if (value) {
      const data = { email: value }
      AuthenticationService.checkEmailAvailability(data)
        .then((response) => {
          const { email_available_flag, message, valid_email } = response
          setEmailAvailability(email_available_flag)
          setEmailAvailabilityMessage(message)
          setIsValidEmail(valid_email)
        })
        .catch((errors) => {
          setError(errors)
        })
    }
  }
  const registerUser = (values) => {
    AuthenticationService.register(values)
      .then((response) => {
        const { message } = response
        setSignUpResponse(message)
      })
      .catch((errors) => {
        setError(errors)
      })
  }

  return (
    <>
      <ReactBootstrap.Button
        variant="link"
        className="p-0 text-dark btn-sm"
        onClick={(e) => {
          e.stopPropagation()
          setIsPaneOpen(true)
        }}
      >
        Register
      </ReactBootstrap.Button>
      <SlidingPane
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        width={isMobileDevice ? '100vw' : '50vw'}
        title={`Register with ${productName}`}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        <div className=" mt-5">
          {!signUpResponse ? (
            <>
              {error ? <components.ErrorDisplay error={error} /> : ''}
              <RegistrationForm
                onSubmit={registerUser}
                isValidEmail={isValidEmail}
                checkEmail={checkIsEmailAvailable}
                isEmailAvailable={isEmailAvailable}
                emailAvailabilityMessage={emailAvailabilityMessage}
                gsxAuthTokenURL={gsxAuthTokenURL}
              />
            </>
          ) : (
            <div class="card bg-success text-white">
              <div class="card-body text-center">{signUpResponse}</div>
            </div>
          )}
        </div>
      </SlidingPane>
    </>
  )
}
